import { useState } from "react";
import Turnstile from "react-turnstile";
import { useForm } from "react-hook-form";
import axios from "axios";

import { isRutValid } from "../../../../../kinto/assets/js/utils";

export const Form = ({ handleOpenModal, setLoading }) => {
    const {
        register,
        formState: { errors },
        handleSubmit,
        setError,
    } = useForm({ mode: "onChange" });

    const [ turnstileToken, setTurnstileToken ] = useState(false);
    const sitekey = document.getElementById("recaptcha_sitekey").getAttribute('value');

    const isVinValid = (vin) => {
        let charactersToExclude = ["i", "I", "o", "O", "q", "Q", "ñ", "Ñ"];
        for (const letter of charactersToExclude) {
            if (vin.includes(letter)) return false;
        }
        return true;
    };

    const onSubmit = (data) => {
        if (!isRutValid(data.rut)) {
            setError("rut", { message: "RUT invalido." });
            return;
        }

        sendData(data);
    };

    const sendData = async (data) => {
        setLoading(true);
        const dataToSend = {
            email: data.email,
            faenaMinera: data.mine_site,
            nombreApellido: data.name,
            razonSocial: data.company_name,
            rut: data.rut.replaceAll(".", "").replace("-", ""),
            vin: data.vin.toUpperCase(),
        };

        try {
            const resp = await axios.post("/api/website/fleet/", dataToSend, {
                headers: {
                    "X-CSRFToken": document.querySelector(
                        'meta[name="csrf-token"]'
                    ).content,
                },
            });
            setLoading(false);
            const data = {
                certificate: resp.data.certificate,
                vin: dataToSend.vin,
            };
            handleOpenModal(data, "success");
        } catch (error) {
            setLoading(false);
            handleOpenModal(null, "error");
        }
    };

    const handleTokenSubmit = (token) => {
        fetch("/recaptcha/", {
            method: "POST",
            body: JSON.stringify({ token: token }),
            headers: {
                "Content-Type": "application/json",
                'X-CSRFToken': document.querySelector('meta[name ="csrf-token"]').content
            },
        })
        .then(response => response.json())
        .then((data) => {
            if (data.success){
                setTurnstileToken(true);
            }
        })
        .catch((error) => {
            console.log("ERROR", error);
        });
    }

    return (
        <form
            id='fleet-certificate-form'
            className='footer-container'
            onSubmit={handleSubmit(onSubmit)}>
            <div className='left-section'>
                <h2 className='subtitle'>Datos Personales</h2>

                <div className='form-element'>
                    <input
                        type='text'
                        name='name'
                        {...register("name", {
                            required: "Este campos es requerido",
                            minLength: {
                                value: 3,
                                message:
                                    "No se permiten menos de 3 caracteres.",
                            },
                        })}
                    />
                    <label htmlFor='flotas-form' className='label'>
                        Nombre y Apellido
                    </label>
                    {errors.name && (
                        <label id='name-error' className='error' htmlFor='name'>
                            {errors.name?.message}
                        </label>
                    )}
                </div>

                <div className='form-element'>
                    <input
                        type='email'
                        name='email'
                        {...register("email", {
                            required: "Este campos es requerido",
                            pattern: {
                                value: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
                                message: "Ingresa un email valido.",
                            },
                        })}
                    />
                    <label htmlFor='flotas-form' className='label'>
                        E-mail
                    </label>
                    {errors.email && (
                        <label
                            id='email-error'
                            className='error'
                            htmlFor='email'>
                            {errors.email?.message}
                        </label>
                    )}
                </div>

                <div className='form-element'>
                    <input
                        type='text'
                        name='rut'
                        {...register("rut", {
                            required: "Este campos es requerido",
                        })}
                    />
                    <label htmlFor='flotas-form' className='label'>
                        RUT
                    </label>
                    {errors.rut && (
                        <label id='rut-error' className='error' htmlFor='rut'>
                            {errors.rut?.message}
                        </label>
                    )}
                </div>

                <div className='form-element'>
                    <input
                        type='text'
                        name='vin'
                        {...register("vin", {
                            required: "Este campos es requerido",
                            validate: (value) =>
                                isVinValid(value) ||
                                "No puede incluir las letras I, O, Q ni Ñ.",
                            minLength: {
                                value: 17,
                                message: "El VIN debe tener 17 caracteres.",
                            },
                            maxLength: {
                                value: 17,
                                message: "El VIN debe tener 17 caracteres.",
                            },
                            pattern: {
                                value: /^[A-Za-z0-9]*$/,
                                message: "Solo debe contener letras y números.",
                            },
                        })}
                    />
                    <label htmlFor='vin' className='label'>
                        VIN
                    </label>
                    {errors.vin && (
                        <label id='vin-error' className='error' htmlFor='vin'>
                            {errors.vin?.message}
                        </label>
                    )}
                </div>
            </div>

            <div className='right-section'>
                <h2 className='subtitle'>Datos de la Empresa</h2>

                <div className='form-element'>
                    <input
                        type='text'
                        name='company_name'
                        {...register("company_name", {
                            required: "Este campos es requerido",
                            minLength: {
                                value: 3,
                                message:
                                    "No se permiten menos de 3 caracteres.",
                            },
                            maxLength: {
                                value: 45,
                                message:
                                    "No se permiten más de 45 caracteres.",
                            },
                        })}
                    />
                    <label htmlFor='flotas-form' className='label'>
                        Empresa
                    </label>
                    {errors.company_name && (
                        <label
                            id='company_name-error'
                            className='error'
                            htmlFor='company_name'>
                            {errors.company_name?.message}
                        </label>
                    )}
                </div>

                <div className='form-element'>
                    <input
                        type='text'
                        name='mine_site'
                        {...register("mine_site", {
                            required: "Este campos es requerido",
                            minLength: {
                                value: 3,
                                message:
                                    "No se permiten menos de 3 caracteres.",
                            },
                            maxLength: {
                                value: 45,
                                message:
                                    "No se permiten más de 45 caracteres.",
                            }
                            
                        })}
                    />
                    <label htmlFor='mine_site' className='label'>
                        Faena Minera
                    </label>
                    {errors.mine_site && (
                        <label
                            id='mine_site-error'
                            className='error'
                            htmlFor='mine_site'>
                            {errors.mine_site?.message}
                        </label>
                    )}
                </div>

                <div className='submit-button'>
                    <small className='disclaimer privacy'>
                        <label className='custom-checkbox'>
                            <input
                                type='checkbox'
                                name='terms'
                                onChange={() => setIsChecked(!isChecked)}
                                {...register("terms", {
                                    required:
                                        "Debes aceptar la política de privacidad.",
                                })}
                            />
                            <span className='checkmark'></span>
                            <label htmlFor='contact-form'></label>
                            {errors.terms && (
                                <label
                                    id='terms-error'
                                    className='error'
                                    htmlFor='terms'>
                                    {errors.terms?.message}
                                </label>
                            )}
                        </label>
                        <span className='terms-text'>
                            He leído y acepto la{" "}
                            <a
                                href='{% pageurl settings.website.GeneralLinkSettings.tnc_page %}'
                                target='_blank'>
                                política de privacidad
                            </a>{" "}
                            de mis datos personales.
                        </span>
                    </small>
                    <Turnstile
                        theme="dark"
                        sitekey={sitekey}
                        onVerify={(token) => {
                            handleTokenSubmit(token);
                        }}
                    />
                    <span className='feedback-message'></span>
                    <button
                        className='btn white'
                        type='submit'
                        id='button-submit'
                        disabled={!turnstileToken}>
                        Obtener certificado
                    </button>
                </div>
            </div>
        </form>
    );
};
